var Rx = require('rx');
require('./dist/rx.dom');
module.exports = Rx;


//////////////////
// WEBPACK FOOTER
// ../node_modules/rx-dom/index.js
// module id = 7
// module chunks = 4